import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { MasterData } from '@/@types/masterData';
import { GetMasterDataUrlResponse } from '@/@types/masterData';
import axios from 'axios';

export class MastersRepository {
  private readonly requestBasePath = 'v1/masters';
  private readonly axios = new TheoryApiAxiosBase();

  async getMasterDataUrl() {
    const response = await this.axios.get<GetMasterDataUrlResponse>(this.requestBasePath);
    return response.data;
  }

  async getMasterData(signedUrl: string) {
    const response = await axios.get<MasterData>(signedUrl);
    return response.data;
  }
}
